export default __webpack_public_path__ + "static/media/blicko.c7f4d12e.svg";